module.exports = __webpack_public_path__ + "img/logo@2x.e0c13125.png";